import { UtilService } from "../../Utils/UtilService";

export const tableDateColumns = [
  "createdAt",
  "updatedAt",
  "deletedAt",
  "authorizedAt",
  "validFrom",
  "validUntil",
  "approvedAt",
  "requestedAt",
];

export const tableBooleanColumns = [
  "isApproved",
  "isActive",
  "isDeleted",
  "isAuthorized",
  "isUpdated",
];

export const tableTitleCaseColumns = [
  "firstName",
  "lastName",
  "middleName",
  "fullName",
];

export const tableBooleanFormat = (cell: Object) => {
  return cell ? "True" : "False";
};

export const tableDateFormat = (cell: Object) => {
  return UtilService.dateFormat(cell?.toString());
};

export const tableTitleCaseFormat = (cell: string) => {
  return UtilService.titleCase(cell?.toString());
};
